// doc/ai/greeting-text-anonymous-trial.md
export const ENDPOINT_GATE = '/api/ai/greeting_gate';

// Mirrors Experiment::AI_GREETING_TRIAL_ARM – the arm that may generate.
export const TRIAL_ARM = 'trial';

// A card text field with the AI trigger; only a form with one is exposed to the test
export const AI_FIELD_SELECTOR = '[data-ai-greeting]';

// The create-request field `Split::formArms()` reads; pinned by
// AiGreetingTrialSplitTest::testFormFieldNameMatchesTheClient.
export const FORM_FIELD = 'ab_ai_greeting_trial';

// `data-ab-ai-greeting-trial` on the card form: ai-text-lib writes the arm the gate
// answered, cardFormLib (another bundle) reads it into the create request.
export const FORM_DATA_KEY = 'abAiGreetingTrial';

// The arm also lives in the tab's sessionStorage: signing in reloads the page
export const STORAGE_KEY = 'ai_greeting_trial_arm';

// Longer than any healthy gate answer; then the trigger falls back to sign-in
export const GATE_TIMEOUT_MS = 4000;
